const storageKey = "access-sso-target";

export const accessSsoTarget = {
	set: (path: string) => sessionStorage.setItem(storageKey, path),
	take: () => {
		const path = sessionStorage.getItem(storageKey);
		sessionStorage.removeItem(storageKey);
		return path;
	},
};
